import { ThemeUIStyleObject } from '@apia/theme';
import boxes from './boxes';
import charts from './charts';
import components from './components';
import fields from './fields';
import modals from './modals';
import tabs from './tabs';
import filters from './filters';
import { upsertion } from './upsertion';
/* IMPORT HERE */

const common: () => ThemeUIStyleObject = () => ({
  boxes,
  charts,
  components,
  fields,
  modals,
  tabs,
  filters,
  upsertion,
  /* PREPEND HERE */
});

export default common;
